import type { CardDirection, FlowThemeCardMotion } from '../../cardMotion';

/** Cards swing along the path like panels on a 3D track. */
export const pyramidCardMotion = (isMobile: boolean): FlowThemeCardMotion => ({
  variants: {
    enter: (direction: CardDirection) => ({
      opacity: 0,
      x: direction > 0 ? (isMobile ? '60%' : '42%') : (isMobile ? '-60%' : '-42%'),
      rotateY: direction > 0 ? -28 : 28,
      scale: 0.92,
    }),
    center: { opacity: 1, x: 0, rotateY: 0, scale: 1 },
    exit: (direction: CardDirection) => ({
      opacity: 0,
      x: direction > 0 ? (isMobile ? '-60%' : '-42%') : (isMobile ? '60%' : '42%'),
      rotateY: direction > 0 ? 28 : -28,
      scale: 0.92,
    }),
  },
  transition: { duration: 0.8, ease: [0.22, 1, 0.36, 1] },
  style: { transformPerspective: 1400 },
});
